module.exports = function(app) {
	app.run(['Service','sessionData', function(Service, sessionData) {
		new Service({
			name: 'summaryOfBenes',
			group: 'eprsvc',
			url: '/eprsvc/x-services/secure/documents/v1/summary-of-benefits',
			headers: {},
			cache: false,

			submitSearch: function(theLid) {
				this.headers['APPID'] = 'EPRWEB';
				this.headers['clientHost'] = 'hmhs.com';
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
				return this.get();
			}
		});
	}]);
};
